import { cloneDeep } from 'lodash';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ReadingListDto } from '../../services/dtos/readingList/readingList.dto';
import { removeReadingListArticle } from '../../services/readingList/readingList.service';
import { Channels } from '../../utils/channels';
import { queryKeys } from '../queryKeyFactory';

export interface RemoveReadingListArticlePayload {
  readingListId: string;
  readingListItemId: string;
}
export default (): UseMutationResult<void, void, RemoveReadingListArticlePayload, void> => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ readingListId, readingListItemId }: RemoveReadingListArticlePayload) => {
      await removeReadingListArticle(readingListId, readingListItemId);
    },
    {
      onSuccess: (_, { readingListId, readingListItemId }) => {
        const readingLists =
          cloneDeep(queryClient.getQueryData<ReadingListDto[]>(queryKeys.fetchReadingLists.all)) || [];

        const readingList = readingLists.find((readingList) => readingList.id === readingListId);

        if (readingList) {
          readingList.articles = readingList?.articles.filter((article) => article.id !== readingListItemId);
          queryClient.setQueryData(queryKeys.fetchReadingLists.all, readingLists);
        }

        Channels.readingListChannel.postMessage(null);
      },
    }
  );
};
